export default "__VITE_ASSET__CvcBiQSI__"